import React, { useEffect } from 'react';

import Error from '@/components/Error';
import { getConfigValue } from '@/helpers/configHelper';

import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

const dsn = getConfigValue('sentryDsn');

Sentry.init({
  dsn,
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.REACT_APP_CLOVER_SPORT_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.replayIntegration()
  ],
  normalizeDepth: 10,
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1
});

export const withSentry = (Component, config = {}) => {
  const { enableErrorBoundary = false, enableProfiler = false } = config;

  let WrappedComponent = Component;

  if (enableErrorBoundary) {
    WrappedComponent = Sentry.withErrorBoundary(WrappedComponent, { fallback: <Error /> });
  }
  if (enableProfiler) {
    WrappedComponent = Sentry.withProfiler(WrappedComponent);
  }

  // Set a display name for easier debugging
  WrappedComponent.displayName = `withSentry(${Component.displayName || Component.name || 'Component'})`;

  return WrappedComponent;
};
